import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../Header/Header';
import CalendarTable from '../Table/Table';

const getRealDays = (startFromToday = true, weekOffset = 0) => {
  const now = new Date();
  const daysOfWeek = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

  const monday = new Date(now);
  const dayOfWeek = now.getDay();
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  monday.setDate(now.getDate() + diffToMonday + weekOffset * 7);

  if (startFromToday) {
    return Array.from({ length: 7 }, (_, i) => {
      const date = new Date(now);
      date.setDate(now.getDate() + i);
      return { day: daysOfWeek[date.getDay()], date: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
    });
  } else {
    return Array.from({ length: 7 }, (_, i) => {
      const date = new Date(monday);
      date.setDate(monday.getDate() + i);
      return { day: daysOfWeek[date.getDay()], date: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
    });
  }
};

const getCurrentWeek = () => {
  const now = new Date();
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const days = Math.floor((now - startOfYear) / (24 * 60 * 60 * 1000));
  return Math.ceil((days + startOfYear.getDay() + 1) / 7);
};

const CalendarDesktopPage = () => {
  const [currentWeek, setCurrentWeek] = useState(getCurrentWeek());
  const [realDays, setRealDays] = useState(getRealDays(false));
  const [showToday, setShowToday] = useState(false);
  const [selectedDelegation, setSelectedDelegation] = useState('Azores Delegation');
  const [visibleGroups, setVisibleGroups] = useState({ Escritório: false, NOC: false });

  const monthName = new Date(realDays[0].year, realDays[0].month - 1).toLocaleString('default', { month: 'long' });
  const weekLabel = `Semana ${monthName}: ${realDays[0].year}`;

  const updateRealDays = (weekOffset) => {
    setRealDays(getRealDays(false, weekOffset));
  };

  const handleNextWeek = () => {
    setCurrentWeek((prev) => prev + 1);
    updateRealDays(currentWeek - getCurrentWeek() + 1);
  };

  const handlePreviousWeek = () => {
    setCurrentWeek((prev) => prev - 1);
    updateRealDays(currentWeek - getCurrentWeek() - 1);
  };

  const handleSelectWeek = (week) => {
    setCurrentWeek(week);
    const weekOffset = week - getCurrentWeek();
    updateRealDays(weekOffset);
  };

  const handleToday = () => {
    setCurrentWeek(getCurrentWeek());
    setRealDays(getRealDays(true));
    setShowToday(false);
  };

  const handleThisWeek = () => {
    setCurrentWeek(getCurrentWeek());
    setRealDays(getRealDays(false));
    setShowToday(true);
  };

  return (
    <div style={{ backgroundColor: '#17296B', minHeight: '100vh', padding: '10px', color: 'white', fontFamily: 'Arial, sans-serif' }}>
      <Header
        weekLabel={weekLabel}
        showToday={showToday}
        onToday={handleToday}
        onThisWeek={handleThisWeek}
        onPrint={() => window.print()}
        onNextWeek={handleNextWeek}
        onPreviousWeek={handlePreviousWeek}
        onSelectWeek={handleSelectWeek}
        currentWeek={currentWeek}
      />
      <CalendarTable
        realDays={realDays}
        delegations={['Azores Delegation', 'Aveiro Delegation']}
        selectedDelegation={selectedDelegation}
        onChangeDelegation={(e) => setSelectedDelegation(e.target.value)}
        employees={{
          Escritório: ['Duarte Rocha', 'Tomás Simas', 'Simão Ferreira', 'Paulo Bettencourt', 'Nuno Paz'],
          NOC: ['Rúben Carneiro', 'Edgar Borges', 'Jorge Santos', 'Mike Maciel', 'Rodrigo Mendes', 'Luís Espanhola'],
        }}
        shifts={[
          { name: 'Escritório', time: '9:00am - 5:00pm', color: '#00AB66' },
          { name: 'NOC', time: '9:00pm - 5:00am', color: '#33B5FF' },
          { name: 'Dia de Descanso', time: '', color: '#FFC300' },
          { name: 'Ausência', time: '', color: '#E9967A' },
        ]}
        visibleGroups={visibleGroups}
        toggleGroupVisibility={(g) => setVisibleGroups((prev) => ({ ...prev, [g]: !prev[g] }))}
      />
    </div>
  );
};

export default CalendarDesktopPage;